import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type TooltipStylesProps = { copied: boolean };

const tooltipStyles = (props: TooltipStylesProps) => css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  .copy-status-icon {
    fill: ${props.copied ? theme.colors.success[50] : theme.colors.white};
  }
`;

const textStylesObject = css`
  transition: all 0.2s ease-in-out;
  :hover {
    cursor: pointer;
    background: ${theme.colors.text.highlight};
    color: ${theme.colors.white};
  }
`;

export const CopyToClipboardStyles = {
  text: textStylesObject,
  tooltip: (props: TooltipStylesProps) => tooltipStyles(props),
};
